import { useState } from "react";

const generateIdempotencyKey = (): string => {
  if (
    typeof crypto !== "undefined" &&
    typeof crypto.randomUUID === "function"
  ) {
    return crypto.randomUUID();
  }

  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 11)}`;
};

/** Returns one stable key for the lifetime of the mounted creation form. */
export const useIdempotencyKey = (): string => {
  const [idempotencyKey] = useState(generateIdempotencyKey);
  return idempotencyKey;
};
